import { render, staticRenderFns } from "./ClaimYourCorner.vue?vue&type=template&id=3c81d7ef&scoped=true"
import script from "./ClaimYourCorner.vue?vue&type=script&lang=js"
export * from "./ClaimYourCorner.vue?vue&type=script&lang=js"
import style0 from "./ClaimYourCorner.vue?vue&type=style&index=0&id=3c81d7ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81d7ef",
  null
  
)

export default component.exports